import {
  FETCH_COMPETENCY_ASSESSMENT_REQUEST,
  FETCH_COMPETENCY_ASSESSMENT_SUCCESS,
  FETCH_COMPETENCY_ASSESSMENT_FAILURE,
  UPDATE_COMPETENCY_ASSESSMENT_FROM_SOCKET,
  SET_COMPETENCY_ACCESS_BLOCKED,
  SET_COMPETENCY_WEBSOCKET_STATUS,
  FETCH_COMPETENCY_ASSESSMENT_IS_NATURAL_USER_TYPE_SUCCESS
} from '../actions/competency.action';

interface CompetencyState {
  data: any[];
  pendingPercentage: number;
  loading: boolean;
  error: any;
  accessBlocked: boolean;
  connected: boolean;
  lastMessage: any;
  hasFetched: boolean; // Track if initial fetch has been done
  isNaturalUserType: boolean; // Track if user is natural type
}

const initialState: CompetencyState = {
  data: [],
  pendingPercentage: 0,
  loading: false,
  error: null,
  accessBlocked: false,
  connected: false,
  lastMessage: null,
  hasFetched: false,
  isNaturalUserType: false, // Default to false
};

const competencyReducer = (state = initialState, action: any): CompetencyState => {
  switch (action.type) {
    case FETCH_COMPETENCY_ASSESSMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_COMPETENCY_ASSESSMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.assessments,
        pendingPercentage: action.payload.pendingPercentage,
        hasFetched: true,
        error: null,
      };

    case FETCH_COMPETENCY_ASSESSMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_COMPETENCY_ASSESSMENT_FROM_SOCKET:
      return {
        ...state,
        lastMessage: action.payload,
      };

    case SET_COMPETENCY_ACCESS_BLOCKED:
      return {
        ...state,
        accessBlocked: action.payload,
      };

    case SET_COMPETENCY_WEBSOCKET_STATUS:
      return {
        ...state,
        connected: action.payload,
      };
      

    case FETCH_COMPETENCY_ASSESSMENT_IS_NATURAL_USER_TYPE_SUCCESS:
      return {
        ...state,
        isNaturalUserType: action?.payload?.isNaturalUserType,
      };

    default:
      return state;
  }
};

export default competencyReducer;
